export default {"src":"/_next/static/media/0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};